import React from 'react'
import config from '../../config'

export default function Footer (){
    return <div className="fixed-bottom text-center" style={config.footerStyle}>
    &copy; CIAM 2022 - {config.version}
    </div>
}